import useEntities from 'hooks/useEntities';
import { entityColumnsToAntColumns } from 'utils/entityColumnsToAntColumns';
import HmsTableWithFilters from 'components/HmsTableWithFilters';

const CompetitionsSeasons = ({ sourceEntityId: id, data: childrenData }) => {
    const entities = useEntities();
    const childEntity = entities.Season;

    return (
        <HmsTableWithFilters
            layoutType='plain'
            exportEnabled={true}
            createButtonLink={`/seasons/_new_?parentId=${id}`}
            onRowClickedLink={(record) => childEntity.entityUrl(record)}
            columns={entityColumnsToAntColumns(childEntity, [
                'name',
                'nick',
                'short',
                'startDate',
                'endDate',
                'status',
            ])}
            data={childrenData}
        />
    )
}

export default CompetitionsSeasons
